import { Check, ShieldCheck } from "lucide-react";
import { Reveal, Label } from "@/components/Reveal";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
};

const INCLUDED = [
  "Valutazione fattibilità del file STL",
  "Stampa FDM con materiali PLA di qualità",
  "Pezzi singoli o piccoli lotti (5–50 pz)",
  "Segnalazione criticità prima di procedere",
];

export default function Offer() {
  return (
    <section data-testid="offer" className="relative py-24 md:py-32 bg-[#0A0E14]">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal className="text-center">
          <Label>07 — L&apos;offerta</Label>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 relative bg-[#111827] border border-[#00C8D7]/30 p-10 md:p-14">
            <div className="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-[#00C8D7] via-[#00C8D7] to-[#F5871F]" />
            <div className="grid md:grid-cols-2 gap-10 items-start">
              <div>
                <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight">
                  Servizio di stampa 3D FDM su misura
                </h3>
                <div className="mt-6 flex items-end gap-2">
                  <span className="font-mono-tech text-sm text-slate-400 mb-2">Da</span>
                  <span className="font-display font-black text-6xl md:text-7xl text-[#00C8D7] leading-none">
                    29€
                  </span>
                  <span className="font-mono-tech text-sm text-slate-400 mb-2">/ progetto</span>
                </div>
                <p className="mt-4 text-slate-400 leading-relaxed">
                  In base a dimensioni, materiale, complessità e quantità.
                </p>
                <button
                  data-testid="offer-cta"
                  onClick={() => scrollTo("quote")}
                  className="mt-8 w-full inline-flex items-center justify-center bg-[#00C8D7] text-[#0A0E14] font-bold px-8 py-4 hover:bg-[#00C8D7]/85 transition-colors"
                >
                  Richiedi ora il preventivo
                </button>
              </div>

              <div className="space-y-4">
                {INCLUDED.map((it, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <Check size={20} className="text-[#00C8D7] mt-0.5 shrink-0" />
                    <span className="text-slate-300">{it}</span>
                  </div>
                ))}
                <div className="mt-6 flex items-start gap-3 border-t border-white/10 pt-6">
                  <ShieldCheck size={22} className="text-[#F5871F] mt-0.5 shrink-0" />
                  <p className="text-sm text-slate-400 leading-relaxed">
                    <span className="text-white font-semibold">Garanzia:</span> se il progetto non è
                    stampabile così com&apos;è, ti segnalo subito criticità e alternative prima di
                    procedere. Zero sprechi di tempo e denaro.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
